import * as React from 'react';
import {useState, useEffect} from 'react';
import {useBOMStore} from 'src/hooks/bom';
import useReduxState from 'src/hooks/useReduxState';
import BomEditSubmitButton from './BomEditSubmitButton';

const BomEditName = (props) => {

    const [{bom_detail_by_bom_id}, {}] = useBOMStore();

    const [isEdit, setIsEdit] = useReduxState(false, 'setIsEdit');
    const [bomName, setBomName] = useState('');

    const editHandler = (status) => {
        setIsEdit(status);
    };

    const onBomNameChange = (name) => {
        setBomName(name);
    };

    useEffect(() => {
        if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
            window.history.back()
        } else {
            setBomName(bom_detail_by_bom_id && bom_detail_by_bom_id.bomName)
        }
    }, [bom_detail_by_bom_id]);

    return (
        <>
            {bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id !== null && Object.keys(bom_detail_by_bom_id).length > 0 &&
            <div className="edit-bom-header">
                <input type="text" className="form-control form-control-sm me-3" id="bomName" placeholder="Enter "
                       name="bomName" value={bomName}
                       onChange={(e) => onBomNameChange(e.target.value)}/>
                <BomEditSubmitButton editData={{bomId: bom_detail_by_bom_id.bomId, bomName: bomName}}/>
                <button className="bs5 btn-link tdn"><b className="text-blue2"
                                                        onClick={() => editHandler(false)}>Cancel</b></button>
            </div>
            }
        </>
    );
}

export default BomEditName;